module.exports = __webpack_public_path__ + "static/img/8.f4bada8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/8.png
// module id = rMRh
// module chunks = 0